import { Component } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ReactComponent as ClearIcon } from 'assets/images/svg/clear.svg';
import { ReactComponent as CalendarIcon } from 'assets/images/svg/calendar.svg';

export default class DatePickerComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
          date: ''
        }
    }

    handleChange = date => {
        this.setState({ date }, () => {
          let formattedDate = date || '';
          if(formattedDate){
            const selectedDate = new Date(date);
            formattedDate = selectedDate.getFullYear() + '-' + ((selectedDate.getMonth() > 8) ? (selectedDate.getMonth() + 1) : ('0' + (selectedDate.getMonth() + 1))) + '-' + ((selectedDate.getDate() > 9) ? selectedDate.getDate() : ('0' + selectedDate.getDate()));
          }
          this.props.dispatchFunction(this.props.name, formattedDate);
        });
    };

    componentDidUpdate(prevProps){
      if(prevProps.refreshGridTime !== this.props.refreshGridTime && this.state.date){
          this.setState({ date: '' });
      }
    }

    clear = () => {
      this.setState({ date: '' }, () => {
        this.props?.dispatchFunction(this.props.name, this.state.date);
      });
    }

    calendarClick = () => {
      if(!this.component?.state?.open){
        this.component.setOpen(true);
      }
    }

    render() {
        const { date } = this.state;
        const { minDate, name, dateFormat, maxDate } = this.props
      return (
        <>
        <div className='date-filter'>
          <DatePicker
            ref={ (r) => {
              this.component = r;
            } }
            showIcon = { true }
            name = { name || null }
            minDate = { minDate || null }
            selected={ date || null }
            onChange={ this.handleChange }
            placeholderText="Select Date"
            dateFormat={ dateFormat || null }
            maxDate={ maxDate || null }
            isClearable={ true }
        />
        <div className="datepicker-placeholder">
          {/* <i className='datepicker-input-wrapper'><CalendarIcon /></i> */}
       </div>
        {/* { this.state.date && <ClearIcon className='clear-icon' onClick={ this.clear } /> }
        { !this.state.date && <CalendarIcon className='calender-icon' onClick={ (e) => { this.calendarClick() } } /> } */}
        </div>
        </>
      )
    }
  }